import $ from 'jquery';
import findIndex from 'lodash/findIndex';
import AlertService from '../common/alert/AlertService';
import EventService from '../common/event/EventService';
import translate from '../common/localization/translate';
import Base from '../vcom/Base';
import SystemListEvent from '../vcom/events/SystemListEvent';
import VcomSection from '../vcom/const/VcomSection';

export default function CyclingSystemsSwitch() {
  const availableTimeIntervals = ['15s', '30s', '1m', '5m', '15m'];
  let intervalObject;
  let selectedTimeIntervalBefore;
  let selectedTimeInterval;
  let systemList;
  let anlagenArrayPosition;

  function shouldCyclingBeVisible() {
    const supportedSections = [
      VcomSection.COCKPIT,
      VcomSection.CONTROL_ROOM,
      VcomSection.DASHBOARD,
      VcomSection.DOCUMENTS,
      VcomSection.EVALUATION,
      VcomSection.MONITORING,
    ];
    return systemList.length > 1 && supportedSections.includes(VCOM.section);
  }

  function toggleVisibility() {
    $('#cycling-systems-control').toggle(shouldCyclingBeVisible());
  }

  function convertTimeInterval(timeInterval) {
    const timeUnit = timeInterval.slice(-1);
    if (timeUnit === 's') {
      return parseInt(timeInterval, 10) * 1000;
    }
    if (timeUnit === 'm') {
      return parseInt(timeInterval, 10) * 1000 * 60;
    }
    return 0;
  }

  function getSystemPosition(anlagenId) {
    const systemIndex = findIndex(systemList, { id: anlagenId });
    return systemIndex !== -1 ? systemIndex : 0;
  }

  function bindListener() {
    EventService.addListener(SystemListEvent.SYSTEM_SELECTED, {
      callback: (event) => {
        VCOM.systemId = event.detail.id;
        anlagenArrayPosition = getSystemPosition(event.detail.id);
        anlagenArrayPosition += 1;
        updateTimer(selectedTimeInterval);
      },
    });
    EventService.addListener(SystemListEvent.FILTER_CHANGED, {
      callback: async () => {
        const data = await Base.getSystems();
        systemList = Base.sortSystems(data);
        anlagenArrayPosition = 0;
        toggleVisibility();
        if (shouldCyclingBeVisible() === false) {
          await switchCyclingSystemsOption(null);
          return;
        }

        updateTimer(selectedTimeInterval);
      },
    });
  }

  function updateTimer(timeInterval) {
    clearInterval(intervalObject);
    if (timeInterval !== null) {
      const convertedTimeInterval = convertTimeInterval(timeInterval);
      setTimeInterval(convertedTimeInterval);
    }
  }

  async function storeOptionsInSession(timeInterval) {
    return $.ajax({
      type: 'POST',
      url: `${VCOM.baseUrl}/default/index/switchcycling`,
      data: {
        timeInterval,
      },
    });
  }

  function changeCyclingSwitch() {
    const cyclingIcon = $('#cycling-systems-icon');
    cyclingIcon.toggleClass('icon-toggle-on', selectedTimeInterval !== null);
    cyclingIcon.toggleClass('icon-toggle-off', selectedTimeInterval === null);
  }

  function changeCyclingText() {
    const displayedCyclingStatus = selectedTimeInterval === null ? '' : `(${selectedTimeInterval})`;
    $('#selected-cycling-systems-control-option').text(displayedCyclingStatus);
  }

  async function requestedCyclingSystemsSwitch(timeInterval) {
    await storeOptionsInSession(timeInterval);

    changeCyclingText();
    changeCyclingSwitch();
    showResponseForUser();
    updateTimer(timeInterval);
  }

  function setTimeInterval(timeInterval) {
    intervalObject = setInterval(() => {
      if (anlagenArrayPosition >= systemList.length) {
        anlagenArrayPosition = 0;
      }
      if (VCOM.section === 'controlRoom') {
        triggerSystemSelected(systemList[anlagenArrayPosition]);
        refreshSystemStatus();
      } else {
        triggerAnlagenebene();
      }
    }, timeInterval);
  }

  function triggerSystemSelected(system) {
    EventService.dispatch(SystemListEvent.SYSTEM_SELECTED, {
      data: {
        id: system.id,
        systemName: system.label,
      },
    });
  }

  function refreshSystemStatus() {
    const systemIds = systemList.map((system) => system.id);
    Base.getAnlagenStatus({ anlagenIds: systemIds });
  }

  function triggerAnlagenebene() {
    anlagenArrayPosition = getSystemPosition(VCOM.systemId);
    anlagenArrayPosition += 1;
    if (anlagenArrayPosition >= systemList.length) {
      anlagenArrayPosition = 0;
    }
    $.ajax({
      type: 'POST',
      url: `${VCOM.baseUrl}/default/index/switchcycling`,
      data: {
        timeInterval: selectedTimeInterval,
      },
      dataType: 'json',
      success() {
        window.location.href = systemList[anlagenArrayPosition].id;
      },
    });
  }

  function setVariables(timeInterval) {
    selectedTimeInterval = shouldCyclingBeVisible() && timeInterval ? timeInterval : null;
    changeCyclingText();
    changeCyclingSwitch();

    anlagenArrayPosition = 0;
  }

  function showResponseForUser() {
    if (selectedTimeInterval === null && selectedTimeIntervalBefore !== null) {
      const infoText = translate('javascript.TX_CYCLING_DEACTIVATE');
      AlertService.showInfo(infoText);
    } else if (selectedTimeInterval !== null && selectedTimeIntervalBefore === null) {
      const infoText = translate('javascript.TX_CYCLING_ACTIVATE');
      AlertService.showInfo(infoText);
    }
  }

  function switchCyclingSystemsOption(timeIntervalParam) {
    const timeInterval = availableTimeIntervals.includes(timeIntervalParam)
      ? timeIntervalParam
      : null;
    selectedTimeIntervalBefore = selectedTimeInterval;
    selectedTimeInterval = timeInterval;
    requestedCyclingSystemsSwitch(timeInterval);
  }

  return {
    async init(timeIntervalParam) {
      const timeInterval = availableTimeIntervals.includes(timeIntervalParam)
        ? timeIntervalParam
        : null;
      const data = await Base.getSystems();
      systemList = Base.sortSystems(data);
      toggleVisibility();
      setVariables(timeInterval);
      updateTimer(selectedTimeInterval);
      bindListener();
    },
    switchCyclingSystemsOption,
  };
}
